export default __webpack_public_path__ + "static/media/text.8b545b59.webp";